import { Injectable } from "@angular/core";
import { IModulePermissions, IRole } from "../models/user-cust-model";
import { HttpClient } from "@angular/common/http";
import { LocalStorageService } from "@coreui/angular-pro";


@Injectable({
  providedIn: "root"
})
export class PermissionsProvider {
  public modulePermissions: IModulePermissions = [];
  public role: IRole | any;
  public roleName: string | undefined;

  constructor(public http: HttpClient, private storage: LocalStorageService) {}

  public LoadRole(roles: any) {
    this.role = roles;
    this.roleName = roles.name;

  }
  public LoadModulePermissions(permissions: IModulePermissions) {
    this.modulePermissions = permissions;
  }

  public hasRolePermission(roleKey: string): boolean {
    return this.role?.[roleKey] === true;
  }

  public isntRolePermission(roleKey: string): boolean {
    return this.role[roleKey] == false;
  }

  public hasModulePermission(permission: string) {
    return this.modulePermissions.some(perm => perm.name === permission);
  }
}
